(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 750;

  function initCarrosselVideos(section) {
    if (section.dataset.cvInitialized === 'true') return;
    section.dataset.cvInitialized = 'true';

    var track = section.querySelector('[data-cv-track]');
    var viewport = section.querySelector('[data-cv-viewport]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cv-item]'));
    var prevButtons = Array.prototype.slice.call(section.querySelectorAll('[data-cv-prev]'));
    var nextButtons = Array.prototype.slice.call(section.querySelectorAll('[data-cv-next]'));
    var desktopVisible = parseInt(section.dataset.desktopVisible, 10) || 4;
    var currentIndex = 0;

    if (!track || !items.length) return;

    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function getVisibleCount() {
      if (isMobile()) return 1.15;
      return Math.min(items.length, desktopVisible);
    }

    function getMaxIndex() {
      var visible = getVisibleCount();
      return Math.max(0, Math.ceil(items.length - visible));
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(index, getMaxIndex()));
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getItemStep() {
      if (!items[0]) return 0;
      return items[0].offsetWidth + getGap();
    }

    function updateItemWidths() {
      var visible = getVisibleCount();
      var gap = getGap();
      var viewportWidth = viewport ? viewport.offsetWidth : section.offsetWidth;

      if (isMobile()) {
        var mobileWidth = (viewportWidth - gap * 0.15) / visible;
        section.style.setProperty('--cv-item-width', mobileWidth + 'px');
      } else {
        var totalGap = gap * (Math.floor(visible) - 1);
        var itemWidth = (viewportWidth - totalGap) / visible;
        section.style.setProperty('--cv-item-width', itemWidth + 'px');
      }
    }

    function updateTrack() {
      track.style.transform = 'translateX(-' + currentIndex * getItemStep() + 'px)';
    }

    function updateNav() {
      var disabledPrev = currentIndex <= 0;
      var disabledNext = currentIndex >= getMaxIndex();

      prevButtons.forEach(function (button) {
        button.disabled = disabledPrev;
      });

      nextButtons.forEach(function (button) {
        button.disabled = disabledNext;
      });
    }

    function playVideo(video) {
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function syncVisibleVideos() {
      var visibleCount = Math.ceil(getVisibleCount());

      items.forEach(function (item, index) {
        var video = item.querySelector('.carrossel-videos__video');
        if (!video) return;

        var shouldPlay = index >= currentIndex && index < currentIndex + visibleCount;

        if (shouldPlay) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    }

    function goTo(index) {
      currentIndex = clampIndex(index);
      updateTrack();
      updateNav();
      syncVisibleVideos();
    }

    function refresh() {
      currentIndex = clampIndex(currentIndex);
      updateItemWidths();
      updateTrack();
      updateNav();
      syncVisibleVideos();
    }

    prevButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    var touchStartX = 0;
    var touchDeltaX = 0;

    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', function (event) {
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-carrossel-videos]').forEach(initCarrosselVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-carrossel-videos]');
    if (section) initCarrosselVideos(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-carrossel-videos]');
    if (!section) return;

    section.querySelectorAll('.carrossel-videos__video').forEach(function (video) {
      video.pause();
    });
  });
})();
